import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-24",
  "use": "icon-icon-nav-24-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-24\"><path d=\"M813.12 498.56l-288-288A63.616 63.616 0 0 0 480 192H256c-35.2 0-64 28.8-64 64v224c0 17.6 7.04 33.6 18.88 45.44l288 288a63.616 63.616 0 0 0 90.24-0.32l224-224A62.592 62.592 0 0 0 832 544c0-17.6-7.36-33.92-18.88-45.44zM304 352a47.936 47.936 0 1 1 0-96 47.936 47.936 0 1 1 0 96z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-24.svg
// module id = ioOq
// module chunks = 3